import { Outlet } from "react-router-dom";
import { ZoneRatesContextProvider } from "./ZoneRatesContext";

export const ZoneRatesRoute = () => (
  <ZoneRatesContextProvider>
    <Outlet />
  </ZoneRatesContextProvider>
);
